export const commercialCardId = card => {
  const id = Number(card?.originalId || String(card?.id || '').replace(/^card-/, ''));
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export const getActiveCommercialCards = cards => {
  const seen = new Set();
  return (Array.isArray(cards) ? cards : []).filter(card => {
    const dealId = Number(card?.dealId || card?.deal?.id);
    const state = card?.deal?.state || card?.outcome || 'open';
    if (!commercialCardId(card) || !Number.isSafeInteger(dealId) || dealId <= 0 || card.archivedAt || state !== 'open' || seen.has(dealId)) return false;
    seen.add(dealId);
    return true;
  });
};

// Existing Deals remain unresolved even when their board stops managing business.
// Quick outcome controls follow the current board capability only.
export const getManagedCommercialCards = cards => getActiveCommercialCards(cards)
  .filter(card => card.kanbanBoard?.enableOutcomeTracking === true);

export const resolveCommercialSelection = (cards, selectedCardId) => {
  const active = getActiveCommercialCards(cards);
  const selected = active.find(card => commercialCardId(card) === Number(selectedCardId));
  return selected || (active.length === 1 ? active[0] : null);
};

export const getCommercialCardContext = (card, ticketId) => ({
  ...(ticketId || card?.linkedTicketId ? { ticketId: Number(ticketId || card.linkedTicketId) } : {}),
  ...(commercialCardId(card) ? { cardId: commercialCardId(card) } : {}),
  ...(card?.dealId || card?.deal?.id ? { dealId: Number(card.dealId || card.deal.id) } : {}),
  ...(card?.kanbanBoardId ? { boardId: Number(card.kanbanBoardId) } : {})
});

export const commercialErrorMessage = error => {
  const code = error?.response?.data?.error || error?.response?.data?.code || error?.message || '';
  if (/CONTEXT_REQUIRED|AMBIGUOUS/.test(code)) return 'Selecione um negócio para continuar.';
  if (/REVISION|CONFLICT|STALE/.test(code)) return 'Este negócio foi atualizado. Revise os dados e tente novamente.';
  if (/IN_PROGRESS|UNKNOWN/.test(code)) return 'A operação está sendo conferida. Tente novamente sem alterar o pedido.';
  return 'Não foi possível atualizar este negócio. Tente novamente.';
};

export const projectCommercialTags = (ticketTags, card, tags) => {
  const general = (ticketTags || []).filter(tag => !tag.kanbanBoardId);
  if (!card?.tagId) return general;
  const stage = (tags || []).find(tag => Number(tag.id) === Number(card.tagId)) || card.tag;
  return stage ? [...general, { ...stage, kanbanBoardId: card.kanbanBoardId }] : general;
};

export const effectiveCommercialOutcome = (event, events) => {
  const snapshot = { ...event.snapshot };
  let invalidated = false;
  [...events].sort((left, right) => Number(left.id) - Number(right.id)).forEach(change => {
    if (Number(change.targetEventId) !== Number(event.id)) return;
    if (change.type === 'corrected') Object.assign(snapshot, change.snapshot?.changes || {});
    if (change.type === 'invalidated') invalidated = true;
  });
  return { ...event, snapshot, invalidated };
};
